import React from "react";
import "../../../../sass/files/service.scss";

const Service = () => {
  return (
    <section className="w-full py-16">
   <section className="services-showcase">
  <div className="services-showcase__intro">
    <span className="services-showcase__eyebrow">What We Handle</span>
    <h2>Everything We Do for Your 3D Prints</h2>
    <p>
      From sculpting to cleanup, print preparation, and worldwide shipping,
      we help turn your idea or rough file into something actually ready to print.
    </p>
  </div>

  <div className="services-showcase__list">
    <div className="service-feature">
      <div className="service-feature__number">01</div>
      <div className="service-feature__content">
        <h3>Custom STL File</h3>
        <p>
          We sculpt detailed, print-ready stl file from your photos or ideas.
        </p>
        <ul>
          <li>Heads, busts & full figures</li>
          <li>From one or multiple references</li>
          <li>Perfect for minis & collectibles</li>
        </ul>
      </div>
    </div>

    <div className="service-feature">
      <div className="service-feature__number">02</div>
      <div className="service-feature__content">
        <h3>AI STL Cleanup & Fixes</h3>
        <p>
          We repair messy or AI-generated meshes so they actually print.
        </p>
        <ul>
          <li>Fix holes, intersections & thin walls</li>
          <li>Smooth surfaces & sharpen details</li>
          <li>Turn “AI output” into print-ready STL</li>
        </ul>
      </div>
    </div>

    <div className="service-feature">
      <div className="service-feature__number">03</div>
      <div className="service-feature__content">
        <h3>Print Optimization</h3>
        <p>
          We prepare files so your printer or ours gets the best result.
        </p>
        <ul>
          <li>Cut & key for large models</li>
          <li>Hollowing & scaling for cost-efficient prints</li>
          <li>Optional custom support setup</li>
        </ul>
      </div>
    </div>

    <div className="service-feature">
      <div className="service-feature__number">04</div>
      <div className="service-feature__content">
        <h3>3D Printing & Shipping</h3>
        <p>
          Don’t have a printer? We can print and ship the model to you.
        </p>
        <ul>
          <li>High-detail resin & FDM printing</li>
          <li>Multiple size & material options</li>
          <li>Worldwide shipping available</li>
        </ul>
      </div>
    </div>
  </div>
</section>
    </section>
  );
};

export default Service;
